import { render, staticRenderFns } from "./simple-drawer.vue?vue&type=template&id=6370cea0&scoped=true&"
import script from "./simple-drawer.vue?vue&type=script&lang=ts&"
export * from "./simple-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./simple-drawer.vue?vue&type=style&index=0&id=6370cea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370cea0",
  null
  
)

export default component.exports